var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-item col"},[_c('label',[_vm._v("Tags")]),_c('div',{staticClass:"layout color-layout"},[_c('div',{staticClass:"row"},_vm._l((_vm.tags),function(item,key){return _c('button',{key:key,class:{
        active: _vm.active.includes(item.id),
      },attrs:{"type":"button","aria-label":`Tags ${item.name}`},on:{"click":function($event){return _vm.$emit('changeActive', 'tags', item.id)}}},[_c('span',{staticClass:"status"}),_vm._v(" "+_vm._s(item.name)+" ")])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }